import axios from "axios";
import { getSessionId } from "./session";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const client = () => axios.create({
  baseURL: `${BACKEND_URL}/api/shojin`,
  headers: { "X-Session-Id": getSessionId() },
});

export const shojinApi = {
  getIdentity: () => client().get("/identity", { params: { session_id: getSessionId() } }).then((r) => r.data),
  setIdentity: (statement) => client().post("/identity", { session_id: getSessionId(), statement }).then((r) => r.data),
  dailyCue:    () => client().get("/daily-cue", { params: { session_id: getSessionId() } }).then((r) => r.data),
  protocol:    () => client().get("/protocol").then((r) => r.data),
  comeback:    () => client().get("/comeback", { params: { session_id: getSessionId() } }).then((r) => r.data),
  addDoubt:    (line) => client().post("/doubt", { session_id: getSessionId(), line }).then((r) => r.data),
  listDoubts:  (days = 14) => client().get("/doubts", { params: { session_id: getSessionId(), days } }).then((r) => r.data),
  curriculum:  () => client().get("/curriculum").then((r) => r.data),
  assessment:  () => client().get("/assessment").then((r) => r.data),
  assess:      (score) => client().post("/assess", { session_id: getSessionId(), score }).then((r) => r.data),
  resilience:  (days = 30) => client().get("/resilience", { params: { session_id: getSessionId(), days } }).then((r) => r.data),
};
